import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.333 12.553v-.104a2.48 2.48 0 0 0 1.524-2.286V3.62a2.476 2.476 0 0 0-2.476-2.476H5.905a2.48 2.48 0 0 0-2.357 1.714h-.153c-.695 0-1.286.245-1.693.727-.395.467-.56 1.09-.56 1.75V12c0 .808.293 1.535.847 2.057.553.52 1.32.797 2.201.797h2.987l3.106.003h.001c.744.004 1.48-.152 2.052-.518.594-.38.997-.987.997-1.787M3.395 4h.034v6.163a2.476 2.476 0 0 0 2.476 2.476h6.282c-.024.318-.184.556-.467.737-.33.212-.83.341-1.431.338h-.003l-3.11-.003H4.19c-.642 0-1.112-.199-1.417-.486-.303-.285-.487-.7-.487-1.225V5.334c0-.484.122-.813.29-1.013.155-.184.405-.32.819-.32m4.622-.19h3.602a.57.57 0 0 1 .571.571v3.603a.572.572 0 0 1-1.142 0V5.76L7.07 9.737a.572.572 0 1 1-.807-.808l3.977-3.976H8.017a.571.571 0 1 1 0-1.143"
    }, null, -1)
  ])))
}
export default { render: render }